export const POWER_BANK_RENT_LOADING = "POWER_BANK_RENT/loading";
export const POWER_BANK_RENT_ERROR = "POWER_BANK_RENT/error";
export const POWER_BANK_RENT_FILTERS = "POWER_BANK_RENT/filters";
export const POWER_BANK_RENT_LIST = "POWER_BANK_RENT/list";



// WEBPACK FOOTER //
// ./src/actions/chargers/rent/constants.js